import { PlusOutlined } from '@ant-design/icons'
import { Button } from 'antd'
import React from 'react'

type MultipleChoiceAddButtonProps = {
  openMultipleChoiceDrawer: () => void
}

export const MultipleChoiceAddButton: React.FC<
  MultipleChoiceAddButtonProps
> = ({ openMultipleChoiceDrawer }) => {
  return (
    <Button
      onMouseDown={() => {
        openMultipleChoiceDrawer()
      }}
      type="link"
      icon={<PlusOutlined />}
    >
      選択肢を追加
    </Button>
  )
}
